import type { IMasterDataDeductionCategoryRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataDeductionCategoryDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataDeductionCategoryUseCase {
  private readonly repository: IMasterDataDeductionCategoryRepository;

  constructor(repository: IMasterDataDeductionCategoryRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataDeductionCategoryDTO) {
    return this.repository.updateDeductionCategory(params);
  }
}
